import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "italic",
  "use": "italic-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"italic\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 2.667C6 2.298 6.298 2 6.667 2h6a.667.667 0 010 1.333h-6A.667.667 0 016 2.667zM2.667 13.333c0-.368.298-.666.666-.666h6a.667.667 0 110 1.333h-6a.667.667 0 01-.666-.667z\" fill=\"#000\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.234 2.042c.345.13.52.514.39.859l-4 10.666a.667.667 0 11-1.248-.468l4-10.666a.667.667 0 01.858-.39z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol